import { css } from '@linaria/core';
import theme from '../../../theme';

export const components = {
  circle: css``,
};

export const spinner = css`
  animation: rotate linear infinite;
  animation-duration: 2000ms;
  color: ${theme.colors.primary['80']};

  & .${components.circle} {
    animation-duration: 1300ms;
    animation-name: dash;
    animation-timing-function: linear;
    animation-iteration-count: infinite;

    fill: none;
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
    stroke-linecap: round;
    stroke: currentColor;
    stroke-width: 3px;
  }
  @keyframes rotate {
    100% {
      transform: rotate(1turn);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -35px;
    }
    100% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -124px;
    }
  }
`;
